export default [
  {
    path: '/printSet', name: 'printSet', component: () => import('@/pages/print/printSet'), meta: { title: '打印设置' },
  },
  {
    path: '/addPrintSet', name: 'addPrintSet', component: () => import('@/pages/print/addPrintSet'), meta: { title: '打印设置' },
  },
  {
    path: '/printRecord', name: 'printRecord', component: () => import('@/pages/print/printRecord'), meta: { title: '打印记录' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/print.js